// extracted by mini-css-extract-plugin
export default {"global":"styles_global__2uo+n"};